import {
  formatDollars,
  formatPercent,
  itemLabel,
} from "@sill/shared/components/marketplace/offer-card";

import type { OfferForBuyer } from "../../lib/marketplace-offers-api";

export function StandingOfferRollup({ offer }: { offer: OfferForBuyer }) {
  const cash = offer.items.cash ?? [];
  const perks = offer.items.perks ?? [];
  const rebate = offer.items.rebate?.find((item) => item.value != null);
  // SILL-525: closing_cost_credit is retired as a selectable item (folded
  // into the rebate per SILL-511) — the rollup's cash column totals the
  // whole dollar lane instead of singling that type out, so grandfathered
  // closing-credit offers and new warranty/inspection offers read the same.
  const cashTotal = cash.reduce((total, item) => total + (item.value ?? 0), 0);

  return (
    <div
      className="border-t border-border pt-3"
      data-testid="standing-offer-rollup"
    >
      <div className="flex items-baseline justify-between gap-3">
        <span className="font-semibold text-foreground">Standing offer</span>
        <span className="text-[10px] text-muted-foreground">
          At your verified tier
        </span>
      </div>
      <dl className="mt-3 grid grid-cols-3 divide-x divide-border">
        <div className="grid gap-0.5 pr-3">
          <dt className="text-[10px] text-muted-foreground">Commission</dt>
          <dd className="tabular-nums text-sm font-semibold text-foreground">
            {offer.commission_pct == null
              ? "—"
              : formatPercent(offer.commission_pct)}
          </dd>
        </div>
        <div className="grid gap-0.5 px-3">
          <dt className="text-[10px] text-muted-foreground">Rebate</dt>
          <dd className="tabular-nums text-sm font-semibold text-foreground">
            {rebate?.value == null ? "—" : formatPercent(rebate.value)}
          </dd>
        </div>
        <div className="grid gap-0.5 pl-3">
          <dt className="text-[10px] text-muted-foreground">Cash incentives</dt>
          <dd className="tabular-nums text-sm font-semibold text-foreground">
            {cashTotal > 0 ? formatDollars(cashTotal) : "—"}
          </dd>
        </div>
      </dl>
      {(cash.length > 0 || perks.length > 0) && (
        <p className="mt-1.5 text-xs text-muted-foreground">
          Includes{" "}
          {[...cash, ...perks]
            .map((item) =>
              item.value == null
                ? itemLabel(item.type).toLowerCase()
                : `${formatDollars(item.value)} ${itemLabel(item.type).toLowerCase()}`,
            )
            .join(" · ")}
        </p>
      )}
    </div>
  );
}
